import { IPhoto, IPhotoRaw } from '@ftd/types'

import { BASE_URL } from '@/api/constants'
import { secureFetch } from '@/api/secure-fetch'

export const apiGetPhotos = async (): Promise<IPhoto[]> => {
  const res = await secureFetch(`${BASE_URL}/photos`)
  if (!res.ok) throw new Error('Failed to fetch photos')
  return res.json()
}

export const apiGetPhotosBySession = async (sessionId: string): Promise<IPhoto[]> => {
  const res = await secureFetch(`${BASE_URL}/photos/session/${sessionId}`)
  if (!res.ok) throw new Error('Failed to fetch photos for session')
  return res.json()
}

export const apiGetPhotosByCatch = async (catchId: string): Promise<IPhotoRaw[]> => {
  const res = await secureFetch(`${BASE_URL}/photos/catch/${catchId}`)
  if (!res.ok) throw new Error('Failed to fetch photos for catch')
  return res.json()
}

export const apiGetPhoto = async (photoId: string): Promise<IPhoto> => {
  const res = await secureFetch(`${BASE_URL}/photos/${photoId}`)
  if (!res.ok) throw new Error('Failed to fetch photo')
  return res.json()
}

export const apiCreatePhoto = async (data: FormData): Promise<IPhoto> => {
  const res = await secureFetch(`${BASE_URL}/photos`, {
    method: 'POST',
    body: data,
  })
  if (!res.ok) throw new Error('Failed to create photo')
  return res.json()
}

export const apiUpdatePhoto = async (photoId: string, data: Partial<IPhoto>): Promise<IPhoto> => {
  const res = await secureFetch(`${BASE_URL}/photos/${photoId}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  })
  if (!res.ok) throw new Error('Failed to update photo')
  return res.json()
}

export const apiDeletePhoto = async (photoId: string): Promise<void> => {
  const res = await secureFetch(`${BASE_URL}/photos/${photoId}`, {
    method: 'DELETE',
  })
  if (!res.ok) throw new Error('Failed to delete photo')
  return res.json()
}

export const apiUploadPhoto = async (data: FormData): Promise<IPhoto> => {
  const res = await secureFetch(`${BASE_URL}/photos`, {
    method: 'POST',
    body: data,
  })
  if (!res.ok) throw new Error('Failed to upload photo')
  return res.json()
}

export const apiUploadPhotoForNote = async (file: File, noteId: string): Promise<IPhoto> => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('noteId', noteId)

  const res = await secureFetch(`${BASE_URL}/photos/notes`, {
    method: 'POST',
    body: formData,
  })
  if (!res.ok) throw new Error('Failed to upload photo for note')
  return res.json()
}
